import React from "react"

import { Drawer } from "@cirrus/ui-kit/src/components/organisms/drawer/index.jsx"
import { useTableContext } from "../../provider"

export const TableDrawer = ({}) => {
  const ctx = useTableContext()
  const { drawerContainerRef } = ctx.props
  const { isOpen, data } = ctx.drawer.state
  const { setOpen } = ctx.drawer.api

  return (
    <>
      {isOpen && (
        <div
          style={{ bottom: 0, left: 0, position: "fixed", right: 0, top: 0, zIndex: 1 }}
          onClick={() => setOpen(false)}
        />
      )}
      <Drawer
        open={isOpen}
        onClose={() => setOpen(false)}
        anchor="right"
        width={390}
        height="100%"
        title={data && data.title}
        container={drawerContainerRef}
        tableInfo={data}
      />
    </>
  )
}
